// Modules
import Overlay from 'praece-react-bootstrap/lib/Overlay';
import Popover from 'praece-react-bootstrap/lib/Popover';
import React from 'react';
import classNames from 'classnames';

import { preventDefault, stopPropagation } from 'utils/event-handlers';
import SVG from 'components/widgets/icons/svg';

export default class FormPopover extends React.Component {
  constructor() {
    super();

    this.state = { showPopover: false };
    this.show = () => this.setState({ showPopover: true });
    this.hide = () => this.setState({ showPopover: false });
    this.toggle = () => this.setState({ showPopover: !this.state.showPopover });
  }

  render() {
    const { children, target, rootClose, placement, hideClose, title, onHide, popoverClassName, ...passed } = this.props;
    const { showPopover } = this.state;

    const header = (
      <div className="w-100 d-flex">
        <span className="p-1">{title}</span>
        { !hideClose && <SVG onClick={this.hide} className="close" src="svg/close.svg" /> }
      </div>
    );

    return (
      <div {...passed}>
        <div onClick={stopPropagation(preventDefault(this.show))}>{target}</div>
        <Overlay
          shouldUpdatePosition
          placement={placement || 'bottom'}
          target={this}
          rootClose={rootClose}
          onHide={onHide || this.hide}
          show={showPopover}
        >
          <Popover
            id="form-popover"
            title={header}
            className={classNames('form-popover', popoverClassName)}
            onClick={stopPropagation()}
            onMouseOver={stopPropagation()}
          >
            {children}
          </Popover>
        </Overlay>
      </div>
    );
  }
}
